import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import FormElement from './FormElement';
import { useForm } from 'react-hook-form';
import { fetchWrapper } from '../../../_helpers/fetchWrapper';
import { toast } from 'react-toastify';
import { isEmpty } from '../../../_helpers';
import { VscLoading } from 'react-icons/vsc';
import { useSelector } from 'react-redux';

function DraftFormInput({ id, hide, form }) {
    const address = useSelector((state) => state.user.address);
    const position = useSelector((state) => state.user.position);
    const { register, handleSubmit } = useForm();
    const [loading, setLoading] = useState(false);

    const multiSubmitElements = [
        {
            key: 'Signature',
            fieldName: 'Signature',
            type: 'signature',
        },
    ];

    const onSubmit = async (data) => {
        try {
            setLoading(true);
            let location = {};
            if (address) {
                location.address = address;
            }
            if (position?.coords) {
                location.coordinates = [position?.coords.longitude, position?.coords.latitude];
            }
            let formData = {
                signature: data['Signature-undefined'],
                submissionId: id,
            };
            if (!isEmpty(location)) {
                formData.location = location;
            }
            await fetchWrapper.patch('userFormData/signature', formData);
            toast.success('Signature submitted succesfully');
            if (typeof hide === 'function') {
                hide();
            }

            setLoading(false);
        } catch (error) {
            console.log(error);
            toast.error('Something went wrong');
            setLoading(false);
        }
    };

    return (
        <div className="p-2 bg-light">
            <form onSubmit={handleSubmit(onSubmit)}>
                {multiSubmitElements.map((form, idx) => (
                    <FormElement form={form} key={idx} elementRef={register} />
                ))}
                <div className="text-center">
                    <Button type="submit" variant="primary" disabled={loading}>
                        {loading ? <VscLoading className="spin" /> : 'Submit'}
                    </Button>
                </div>
            </form>
        </div>
    );
}

export default DraftFormInput;
